
    import '/opt/buildhome/repo/components/actions/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["actions-demo-basic","actions-demo-sub","actions-demo-variant"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/actions/index.en-US.md?type=demo')
};